import {ClientSettingsDropdownItem} from "../../../components/header/top-header-right/client-settings/dropdown/dropdown.component";
import {ServiceBase} from "../../ServiceBase";
import {IClientSettingsSectionRendererModel} from "./section-renderer-model.interface";

export class LanguageSwitcherRenderer extends ServiceBase implements IClientSettingsSectionRendererModel {
    async isAvailable(): Promise<Boolean> {
        if (this.services.configuration.data?.clientSettings?.languageSwitcher?.display
            && !this.services.language.languageSwitcher.isEmpty) {
            return true
        };

        return false
    }

    render(): React.ReactElement {
        return (<ClientSettingsDropdownItem
            key={this.services.tools.getGuid()}
            icon={this.services.theme.currentTheme.icons.bubbleGlobeIcon}
            title={this.services.translation.translate('LANGUAGE')}
            infoTooltipText={this.services.translation.translate('LANGUAGES_COUNTRY_CHOOSE_INFO')}
            selected={this.services.clientSettings.currentLanguageOrCountry?.title}
            lists={this.services.clientSettings.languageSwitcherDropdownLists}
        />);
    }
}